import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Spinner/spinner';
import { css } from '@patternfly/react-styles';
export var spinnerSize;

(function (spinnerSize) {
  spinnerSize["sm"] = "sm";
  spinnerSize["md"] = "md";
  spinnerSize["lg"] = "lg";
  spinnerSize["xl"] = "xl";
})(spinnerSize || (spinnerSize = {}));

export var Spinner = function Spinner(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'xl' : _a$size,
      _a$ariaValuetext = _a['aria-valuetext'],
      ariaValueText = _a$ariaValuetext === void 0 ? 'Loading...' : _a$ariaValuetext,
      props = __rest(_a, ["className", "size", 'aria-valuetext']);

  return React.createElement("span", Object.assign({
    className: css(styles.spinner, styles.modifiers[size]),
    role: "progressbar",
    "aria-valuetext": ariaValueText
  }, props), React.createElement("span", {
    className: css(styles.spinnerClipper)
  }), React.createElement("span", {
    className: css(styles.spinnerLeadBall)
  }), React.createElement("span", {
    className: css(styles.spinnerTailBall)
  }));
};